import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { getEndpoint } from 'utils/getEndpoint';
import * as SERVICE_ENDPOINTS from 'constants/endpoints';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc HeaderAndFooter defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { HeaderService } from 'services/headerAndFooter';
 *
 * // create service instance and send/cancel request
 * const headerService = new HeaderService();
 * const result = await headerService.postData( '<user-id>' ); // fetch data
 * headerService.cancel(); // cancel an active request
 */
export class HeaderService extends HttpService {

    // make request and fetch data
    async postData( { data = {} } = {} ) {
        const response = await this.post( {
            host: CONFIG.host,
            path: getEndpoint( SERVICE_ENDPOINTS.SITE_HEADER ),  // get endpoint url path
            data,
        } );
        return {
            status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
            headerUrls: get( response, 'body.component.elements.urls', {} ),
            navigations: get( response, 'body.component.structure.navigation', [] ),
            metaData: get( response, 'body.component.structure.metaData', {} ),
            visibility: get( response, 'body.component.visibility', {} ),
        };
    }

    // submit ePost ID
    async submitEpostId( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data,
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
    
    // handle logout
    async handleLogout( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data,
            } );
            return {
                status: get( response, 'status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: get( response, 'body.component.data.state', get( response, 'body.component.data', {} ) ),
            }
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}

/**
 * @type {class}
 * @desc HeaderAndFooter defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { FooterService } from 'services/headerAndFooter';
 *
 * // create service instance and send/cancel request
 * const footerService = new FooterService();
 * const result = await footerService.postData( '<user-id>' ); // fetch data
 * footerService.cancel(); // cancel an active request
 */
export class FooterService extends HttpService {

    // make request and fetch data
    async postData( { data = {} } = {} ) {
        const response = await this.post( {
            host: CONFIG.host,
            path: getEndpoint( SERVICE_ENDPOINTS.SITE_FOOTER ),  // get endpoint url path
            data,
        } );

        return {
            status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
            component: get( response, 'body.component', {} ),
        };
    }
}
